import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  insertMemberAddress,
  updateMemberAddress,
} from "../../../../api/memberAddress";
import { failAlert, successAlert } from "../../../../common/alert";
import PostCode from "../../../../common/postcode";
import { AddressSchema } from "../../../../common/util/addressYup";
import KakaoMap from "../../../map/Maptainer";

const pageWrapStyle = {
  width: "100%",
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  marginBottom: "22px",
};

const backButtonStyle = {
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  border: "1px solid #e5e7eb",
  background: "#fff",
  color: "#333",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  fontSize: "15px",
};

const titleStyle = {
  margin: 0,
  fontSize: "24px",
  fontWeight: 800,
  color: "#222",
};

const subTextStyle = {
  margin: "5px 0 0",
  fontSize: "14px",
  color: "#777",
};

const cardStyle = {
  width: "100%",
  maxWidth: "760px",
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: "16px",
  padding: "30px",
  boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
};

const formRowStyle = {
  display: "grid",
  gridTemplateColumns: "120px 1fr",
  gap: "14px",
  alignItems: "center",
  marginBottom: "16px",
};

const labelStyle = {
  fontSize: "14px",
  fontWeight: 700,
  color: "#333",
};

const inputStyle = {
  width: "100%",
  height: "44px",
  border: "1px solid #ddd",
  borderRadius: "9px",
  padding: "0 13px",
  fontSize: "14px",
  background: "#fff",
};

const readOnlyInputStyle = {
  ...inputStyle,
  background: "#f9fafb",
  color: "#555",
};

const addressSearchButtonStyle = {
  width: "120px",
  height: "44px",
  border: "1px solid #3BB77E",
  borderRadius: "9px",
  background: "#3BB77E",
  color: "#fff",
  fontWeight: 700,
  cursor: "pointer",
  flex: "0 0 120px",
};

const buttonAreaStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
  marginTop: "28px",
  paddingTop: "22px",
  borderTop: "1px solid #f1f1f1",
};

const leftButtonGroupStyle = {
  display: "flex",
  gap: "8px",
};

const rightButtonGroupStyle = {
  display: "flex",
  gap: "8px",
};

const cancelButtonStyle = {
  height: "42px",
  padding: "0 18px",
  border: "1px solid #ddd",
  borderRadius: "8px",
  background: "#fff",
  color: "#333",
  fontWeight: 700,
  cursor: "pointer",
};

const deleteButtonStyle = {
  height: "42px",
  padding: "0 18px",
  border: "1px solid #f1c5c5",
  borderRadius: "8px",
  background: "#fff",
  color: "#d33",
  fontWeight: 700,
  cursor: "pointer",
};

const submitButtonStyle = {
  height: "42px",
  padding: "0 24px",
  border: "1px solid #3BB77E",
  borderRadius: "8px",
  background: "#3BB77E",
  color: "#fff",
  fontWeight: 700,
  cursor: "pointer",
};

const errorTextStyle = {
  margin: "6px 0 0",
  fontSize: "12px",
  color: "#d33",
};

const mobileRowStyle = {
  width: "100%",
};

const NewMyAddress = (props) => {
  const { register, handleSubmit, formState, reset } = useForm({
    resolver: yupResolver(AddressSchema),
  });

  const { errors } = formState;

  const [mapInputs, setMapInputs] = useState({
    addressGps: {
      mapx: "",
      mapy: "",
    },
  });

  const [pickAddress, setPickAddress] = useState({
    address: "",
  });

  const [postOpen, setPostOpen] = useState(false);

  const handlePostModal = () => {
    setPostOpen((prev) => !prev);
  };

  const onCompleteAddressCode = (postcode) => {
    const doroAddr = postcode.roadAddress
      ? postcode.roadAddress
      : postcode.autoRoadAddress;

    const baseAddr = postcode.jibunAddress
      ? postcode.jibunAddress
      : postcode.autoJibunAddress;

    setPickAddress({
      ...postcode,
      address: doroAddr || baseAddr,
    });

    reset({
      addr_name: props.isEdit ? props.editAddress?.name : "",
      zipcode: postcode.zonecode,
      doro_addr: doroAddr,
      base_addr: baseAddr,
      detail_addr: props.isEdit ? props.editAddress?.detail_addr : "",
      mapx: props.editAddress?.mapx,
      mapy: props.editAddress?.mapy,
    });

    setPostOpen(false);
  };

  const createAddress = async (data) => {
    const body = {
      modes: "InsertSet",
      addr_name: data.addr_name,
      zipcode: data.zipcode,
      doro_addr: data.doro_addr,
      base_addr: data.base_addr,
      detail_addr: data.detail_addr,
      mapx: mapInputs.addressGps?.mapx,
      mapy: mapInputs.addressGps?.mapy,
    };

    const res = await insertMemberAddress(body);

    if (res?.code === "0000") {
      successAlert("등록 되었습니다.");
      props.setIsOpen(false);
      props.fetchAddressList();
    } else {
      failAlert(res?.data?.Msg);
    }
  };

  const updateAddress = async (data) => {
    const body = {
      modes: "UpdateSet",
      acode: props.editAddress.acode,
      addr_name: data.addr_name,
      zipcode: data.zipcode,
      doro_addr: data.doro_addr,
      base_addr: data.base_addr,
      detail_addr: data.detail_addr,
      mapx: mapInputs.addressGps?.mapx || data.mapx,
      mapy: mapInputs.addressGps?.mapy || data.mapy,
    };

    const res = await updateMemberAddress(body);

    if (res?.code === "0000") {
      successAlert("수정되었습니다.");
      props.setIsEdit(false);
      props.setIsOpen(false);
      props.fetchAddressList();
    } else {
      failAlert(res?.data?.Msg || "수정에 실패했습니다.");
    }
  };

  const backToList = () => {
    props.setIsOpen(false);
    props.setIsEdit(false);
    reset();
  };

  const deleteCurrentAddress = () => {
    props.deleteAddress(props.editAddress?.acode);
    props.setIsEdit(false);
    props.setIsOpen(false);
  };

  useEffect(() => {
    if (props.isEdit === true && props.editAddress) {
      reset({
        addr_name: props.editAddress.name,
        zipcode: props.editAddress.zipcode,
        doro_addr: props.editAddress.doro_addr,
        base_addr: props.editAddress.base_addr,
        detail_addr: props.editAddress.detail_addr,
        mapx: props.editAddress.mapx,
        mapy: props.editAddress.mapy,
      });

      setPickAddress({
        address:
          props.editAddress.doro_addr ||
          props.editAddress.base_addr ||
          "",
      });
    }
  }, [props.isEdit, props.editAddress, reset]);

  return (
    <>
      <div style={pageWrapStyle}>
        <div style={headerStyle}>
          <div>
            <h3 style={titleStyle}>
              {props.isEdit ? "배송지 수정" : "배송지 등록"}
            </h3>
            <p style={subTextStyle}>
              {props.isEdit
                ? "등록된 배송지 정보를 수정할 수 있습니다."
                : "새로운 배송지를 등록할 수 있습니다."}
            </p>
          </div>
        </div>

        <div style={cardStyle}>
          <form
            onSubmit={handleSubmit((data) =>
              props.isEdit ? updateAddress(data) : createAddress(data)
            )}
          >
            <div style={formRowStyle}>
              <label style={labelStyle}>배송지 이름</label>
              <div style={mobileRowStyle}>
                <input
                  type="text"
                  placeholder="예: 회사, 집, 물류창고"
                  {...register("addr_name")}
                  style={inputStyle}
                />
                {errors?.addr_name && (
                  <p style={errorTextStyle}>{errors.addr_name.message}</p>
                )}
              </div>
            </div>

            <div style={formRowStyle}>
              <label style={labelStyle}>우편번호</label>
              <div style={mobileRowStyle}>
                <div style={{ display: "flex", gap: "8px" }}>
                  <input
                    type="text"
                    readOnly
                    {...register("zipcode")}
                    style={readOnlyInputStyle}
                  />
                  <button
                    type="button"
                    onClick={handlePostModal}
                    style={addressSearchButtonStyle}
                  >
                    주소 검색
                  </button>
                </div>
                {errors?.zipcode && (
                  <p style={errorTextStyle}>{errors.zipcode.message}</p>
                )}
              </div>
            </div>

            <div style={formRowStyle}>
              <label style={labelStyle}>도로명 주소</label>
              <div style={mobileRowStyle}>
                <input
                  type="text"
                  readOnly
                  {...register("doro_addr")}
                  style={readOnlyInputStyle}
                />
                {errors?.doro_addr && (
                  <p style={errorTextStyle}>{errors.doro_addr.message}</p>
                )}
              </div>
            </div>

            <div style={formRowStyle}>
              <label style={labelStyle}>지번 주소</label>
              <div style={mobileRowStyle}>
                <input
                  type="text"
                  readOnly
                  {...register("base_addr")}
                  style={readOnlyInputStyle}
                />
                {errors?.base_addr && (
                  <p style={errorTextStyle}>{errors.base_addr.message}</p>
                )}
              </div>
            </div>

            <div style={formRowStyle}>
              <label style={labelStyle}>상세 주소</label>
              <div style={mobileRowStyle}>
                <input
                  type="text"
                  placeholder="상세주소를 입력해주세요"
                  {...register("detail_addr")}
                  style={inputStyle}
                />
                {errors?.detail_addr && (
                  <p style={errorTextStyle}>{errors.detail_addr.message}</p>
                )}
              </div>
            </div>

            <div style={buttonAreaStyle}>
              <div style={leftButtonGroupStyle}>
                {props.isEdit && (
                  <button
                    type="button"
                    onClick={deleteCurrentAddress}
                    style={deleteButtonStyle}
                  >
                    삭제
                  </button>
                )}
              </div>

              <div style={rightButtonGroupStyle}>
                <button
                  type="button"
                  onClick={backToList}
                  style={cancelButtonStyle}
                >
                  취소
                </button>

                <button type="submit" style={submitButtonStyle}>
                  {props.isEdit ? "수정하기" : "등록하기"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {postOpen && (
        <PostCode
          onClickHandleModal={handlePostModal}
          onCompletePostCode={onCompleteAddressCode}
          isCheckout={props.isCheckout}
        />
      )}

      <div style={{ display: "none" }}>
        <KakaoMap
          address={pickAddress.address}
          setUserInputs={setMapInputs}
          userinputs={mapInputs}
        />
      </div>
    </>
  );
};

export default NewMyAddress;